import { Link } from 'react-router-dom'
import { StatusMessage } from '../components/StatusMessage'

export function NotFoundPage() {
  return (
    <div className="stack-lg">
      <header className="page-header">
        <h1>Page not found</h1>
      </header>
      <StatusMessage tone="empty" title="There is nothing at this address">
        <p>
          <Link to="/search">Search the disclosure archive</Link> instead.
        </p>
      </StatusMessage>
    </div>
  )
}
